var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSavedApplication(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 145,
    viewBox: "0 0 158 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_482_409)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 157,
    height: 144,
    transform: "translate(0.5 0.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.705 98.4252H84.2489C83.2394 98.4252 82.4179 97.5982 82.4179 96.5819V13.7945C82.4179 12.7782 83.2394 11.9512 84.2489 11.9512H140.705C141.715 11.9512 142.536 12.7779 142.536 13.7945V96.5816C142.536 97.5982 141.715 98.4252 140.705 98.4252ZM84.2489 12.0298C83.2822 12.0298 82.496 12.8216 82.496 13.7945V96.5816C82.496 97.5548 83.2825 98.3463 84.2489 98.3463H140.705C141.672 98.3463 142.458 97.5545 142.458 96.5816V13.7945C142.458 12.8216 141.672 12.0298 140.705 12.0298H84.2489Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6037 98.4252H19.1473C18.1378 98.4252 17.3163 97.5982 17.3163 96.5819V13.7945C17.3163 12.7782 18.1375 11.9512 19.1473 11.9512H75.6037C76.6133 11.9512 77.4347 12.7779 77.4347 13.7945V96.5816C77.4351 97.5982 76.6136 98.4252 75.6037 98.4252ZM19.1473 12.0298C18.1809 12.0298 17.3944 12.8216 17.3944 13.7945V96.5816C17.3944 97.5548 18.1809 98.3463 19.1473 98.3463H75.6037C76.5705 98.3463 77.3567 97.5545 77.3567 96.5816V13.7945C77.3567 12.8216 76.5702 12.0298 75.6037 12.0298H19.1473Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.223 117.629H2.04688V117.707H158.223V117.629Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4059 19.9364H68.2672C68.5258 19.9364 68.7357 19.7251 68.7357 19.4647V17.2236C68.7357 16.9633 68.5258 16.752 68.2672 16.752H58.4059C58.147 16.752 57.9374 16.9633 57.9374 17.2236V19.4647C57.9374 19.7251 58.147 19.9364 58.4059 19.9364Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5154 23.999H62.3767C62.6353 23.999 62.8452 23.7877 62.8452 23.5274V21.2862C62.8452 21.0259 62.6353 20.8146 62.3767 20.8146H52.5154C52.2568 20.8146 52.0469 21.0259 52.0469 21.2862V23.5274C52.0469 23.788 52.2568 23.999 52.5154 23.999Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0886 67.703H22.2273C21.9687 67.703 21.7588 67.4917 21.7588 67.2313V64.9902C21.7588 64.7299 21.9687 64.5186 22.2273 64.5186H32.0886C32.3472 64.5186 32.5571 64.7299 32.5571 64.9902V67.2313C32.5571 67.492 32.3472 67.703 32.0886 67.703Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9782 71.7636H28.117C27.8583 71.7636 27.6484 71.5523 27.6484 71.2919V69.0508C27.6484 68.7904 27.8583 68.5791 28.117 68.5791H37.9782C38.2369 68.5791 38.4468 68.7904 38.4468 69.0508V71.2919C38.4468 71.5526 38.2369 71.7636 37.9782 71.7636Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.125 70.913H117.263C117.005 70.913 116.795 70.7017 116.795 70.4413V68.2002C116.795 67.9395 117.005 67.7285 117.263 67.7285H127.125C127.383 67.7285 127.593 67.9395 127.593 68.2002V70.4413C127.593 70.7017 127.384 70.913 127.125 70.913Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.906 70.913H129.045C128.786 70.913 128.576 70.7017 128.576 70.4413V68.2002C128.576 67.9395 128.786 67.7285 129.045 67.7285H138.906C139.165 67.7285 139.374 67.9395 139.374 68.2002V70.4413C139.374 70.7017 139.165 70.913 138.906 70.913Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.013 74.9743H123.152C122.894 74.9743 122.684 74.763 122.684 74.5026V72.2615C122.684 72.0011 122.894 71.7898 123.152 71.7898H133.013C133.272 71.7898 133.482 72.0011 133.482 72.2615V74.5026C133.482 74.763 133.272 74.9743 133.013 74.9743Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.736 90.5968H133.47V117.628H144.736V90.5968Z",
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.113 90.5968H109.262V117.628H136.113V90.5968Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.717 90.5968H121.4V117.55H124.717V90.5968Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2231 90.5955H40.9572V117.627H52.2231V90.5955Z",
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5992 90.5955H16.7482V117.627H43.5992V90.5955Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2034 90.5955H28.8859V117.549H32.2034V90.5955Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.263 104.976H97.9969V117.629H109.263V104.976Z",
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.64 104.976H73.7891V117.629H100.64V104.976Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2443 104.976H85.9268V117.592H89.2443V104.976Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4905 77.9445H46.2246V90.5977H57.4905V77.9445Z",
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8667 77.9445H22.0156V90.5977H48.8667V77.9445Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4709 77.9445H34.1534V90.561H37.4709V77.9445Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.982 18.0098H88.2998V42.8582H112.982V18.0098Z",
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.733 41.6014V19.2686L89.5493 19.2686V41.6014H111.733Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1545 36.5291C99.1545 36.5291 103.228 28.1216 111.733 27.953V41.6009H100.641L99.1545 36.5291Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5498 34.1683C89.5498 34.1683 93.2128 32.235 96.9357 33.6542C101.611 35.4362 104.322 41.6007 104.322 41.6007H89.5498V34.1683Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1596 30.2872C99.3212 30.2872 101.073 28.5232 101.073 26.3471C101.073 24.1711 99.3212 22.407 97.1596 22.407C94.9981 22.407 93.2459 24.1711 93.2459 26.3471C93.2459 28.5232 94.9981 30.2872 97.1596 30.2872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7462 18.0098H21.0918V60.2138H42.7462V18.0098Z",
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.497 58.9569L41.497 19.2685L22.3414 19.2685L22.3414 58.9569H41.497Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9743 35.5052C31.1358 35.5052 32.8881 33.7412 32.8881 31.5651C32.8881 29.389 31.1358 27.625 28.9743 27.625C26.8128 27.625 25.0605 29.389 25.0605 31.5651C25.0605 33.7412 26.8128 35.5052 28.9743 35.5052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9229 58.9557C25.9229 58.9557 30.7709 35.488 41.4974 33.3809V58.9557H31.9197H25.9229Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3416 45.0282C22.3416 45.0282 24.8095 42.6327 28.7192 44.0647C36.0664 46.7558 40.1672 58.9556 40.1672 58.9556H22.3416V45.0282Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.886 36.4272C132.47 35.9807 135.016 32.6937 134.572 29.0854C134.129 25.4771 130.864 22.914 127.28 23.3605C123.696 23.807 121.15 27.094 121.593 30.7023C122.037 34.3106 125.302 36.8737 128.886 36.4272Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.956 31.2793C134.714 28.0182 132.703 24.7558 129.463 23.9925C126.224 23.2292 122.984 25.2541 122.225 28.5152C121.467 31.7763 123.479 35.0387 126.718 35.802C129.957 36.5652 133.198 34.5404 133.956 31.2793Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.101 24.3818H127.875V25.6466H128.101V24.3818Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.102 34.1152H127.877V35.38H128.102V34.1152Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.779 29.7676H122.522V29.9946H123.779V29.7676Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.446 29.7676H132.189V29.9946H133.446V29.7676Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.771 25.9184L130.883 26.8126L131.042 26.9731L131.931 26.079L131.771 25.9184Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.933 32.7891L124.045 33.6838L124.204 33.8443L125.092 32.9496L124.933 32.7891Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.212 25.9146L124.053 26.0752L124.941 26.9694L125.101 26.8088L124.212 25.9146Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.043 32.7957L130.884 32.9562L131.772 33.8507L131.931 33.6902L131.043 32.7957Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.952 29.7271L127.881 29.9082L130.011 30.7526L130.082 30.5715L127.952 29.7271Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.082 29.9792H124.568V29.7846H127.888V27.0391H128.082V29.9792Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.128 131.399C148.128 132.499 117.957 133.391 80.741 133.391C43.5246 133.391 13.3545 132.499 13.3545 131.399C13.3545 130.299 43.5246 129.407 80.741 129.407C117.957 129.407 148.128 130.299 148.128 131.399Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9024 54.04L104.828 59.3908H79.1193L74.0957 54.04H98.9024Z",
    fill: "#11274B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M98.9024 54.04L104.828 59.3908H79.1193L74.0957 54.04H98.9024Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9128 54.04H74.0945V79.0252H98.9128V54.04Z",
    fill: "#11274B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M98.9128 54.04H74.0945V79.0252H98.9128V54.04Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9403 54.04H66.1221V79.0252H90.9403V54.04Z",
    fill: "#11274B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1346 54.04L60.209 59.3908H85.9178L90.9413 54.04H66.1346Z",
    fill: "#11274B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M66.1346 54.04L60.209 59.3908H85.9178L90.9413 54.04H66.1346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9376 62.6494C81.2512 62.6494 82.8223 64.0226 82.8223 66.282C82.8223 68.7325 81.0959 69.8105 78.7823 69.8105L78.7136 71.1837H77.0041L76.9179 68.4545H77.4876C79.4389 68.4545 80.941 68.1071 80.941 66.282C80.941 65.0654 80.1985 64.3179 78.9554 64.3179C77.7297 64.3179 76.9529 65.0128 76.9529 66.2298H75.1056C75.0872 64.127 76.5896 62.6494 78.9376 62.6494ZM77.8325 75.025C77.1244 75.025 76.5721 74.4688 76.5721 73.7565C76.5721 73.0437 77.1247 72.4877 77.8325 72.4877C78.5231 72.4877 79.0756 73.044 79.0756 73.7565C79.0759 74.4688 78.5234 75.025 77.8325 75.025Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0166 79.0283H62.7607V81.6169H92.0166V79.0283Z",
    fill: "#11274B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M92.0166 79.0283H62.7607V81.6169H92.0166V79.0283Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.884 79.0283H92.0178V81.6169H102.884V79.0283Z",
    fill: "#11274B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M102.884 79.0283H92.0178V81.6169H102.884V79.0283Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1236 81.6172H80.3604V130.323H82.1236V81.6172Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M82.1236 81.6172H80.3604V130.323H82.1236V81.6172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M82.1236 82.8294L80.3604 83.5633V81.6172H82.1236V82.8294Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8614 131.899H72.6211V131.89C72.6211 130.478 73.7584 129.333 75.1608 129.333H87.3213C88.7241 129.333 89.8611 130.478 89.8611 131.89V131.899H89.8614Z",
    fill: "#11274B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9521 105.932C28.9521 105.932 31.0843 105.149 31.6362 107.422C32.1881 109.695 33.768 109.108 34.0669 108.61C34.6563 107.629 34.7388 104.078 33.7252 103.864C32.5148 103.608 29.3788 104.897 28.9521 105.932Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9521 105.932C28.9521 105.932 31.0843 105.149 31.6362 107.422C32.1881 109.695 33.768 109.108 34.0669 108.61C34.6563 107.629 34.7388 104.078 33.7252 103.864C32.5148 103.608 29.3788 104.897 28.9521 105.932Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.7235 103.865C31.2228 103.902 30.5612 106.113 30.1595 108.061L29.3468 106.534L29.9231 109.245C29.8613 109.541 29.7966 109.814 29.7223 110.052C29.1204 111.972 27.2637 112.557 27.2637 112.557C27.2637 112.557 27.1516 111.777 27.0529 110.682V110.681L27.9628 109.24L26.9739 109.659C26.8633 107.941 26.8483 105.876 27.2637 104.698C28.0668 102.426 30.2211 103.125 30.2211 103.125L33.7235 103.865Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9559 101.482C39.9559 101.482 38.6453 101.085 37.2719 102.972C35.9484 104.791 35.4209 105.004 34.5238 104.297C33.6267 103.59 34.1693 99.6279 35.1825 99.4138C36.3932 99.1581 39.5295 100.447 39.9559 101.482Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9559 101.482C39.9559 101.482 38.6453 101.085 37.2719 102.972C35.9484 104.791 35.4209 105.004 34.5238 104.297C33.6267 103.59 34.1693 99.6279 35.1825 99.4138C36.3932 99.1581 39.5295 100.447 39.9559 101.482Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.1696 111.807C44.1696 111.807 42.5388 111.293 41.4212 109.748L42.8668 106.332L40.8846 108.82C40.8012 108.634 40.7259 108.439 40.661 108.232C39.8017 105.492 39.9775 99.5452 35.0371 99.4732L39.9488 98.3452C39.9488 98.3452 43.0236 97.3465 44.169 100.591C44.461 101.416 44.6041 102.548 44.6553 103.776L42.8665 102.109C42.8665 102.109 44.1068 103.921 44.6772 104.677C44.7062 108.074 44.1696 111.807 44.1696 111.807Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4551 96.2147C27.4551 96.2147 29.5872 95.4317 30.1391 97.7046C30.691 99.9774 33.4675 100.845 33.7524 99.7344C34.0563 98.5492 33.3845 94.3273 32.3712 94.1132C31.1605 93.8576 27.8814 95.1792 27.4551 96.2147Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4551 96.2147C27.4551 96.2147 29.5872 95.4317 30.1391 97.7046C30.691 99.9774 33.4675 100.845 33.7524 99.7344C34.0563 98.5492 33.3845 94.3273 32.3712 94.1132C31.1605 93.8576 27.8814 95.1792 27.4551 96.2147Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.4596 94.1264C28.4205 94.1855 27.7434 98.2174 27.1608 101.184L25.1027 98.1954C25.129 98.2819 26.2203 101.848 26.6423 103.262C25.6909 105.759 23.2399 106.532 23.2399 106.532C23.2399 106.532 22.5536 101.76 22.7741 98.097C23.376 97.5954 24.4402 96.697 24.4402 96.697L22.8629 97.0901C22.9425 96.4181 23.0646 95.8118 23.2399 95.3156C24.3853 92.0724 27.461 93.0708 27.461 93.0708L32.4596 94.1264Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0694 113.989C34.0641 113.989 34.0591 113.989 34.0535 113.988C33.9763 113.98 33.9204 113.909 33.9292 113.832C35.3279 101.301 31.8236 90.7355 31.788 90.6305C31.7627 90.5563 31.8024 90.4758 31.8758 90.4507C31.9501 90.4261 32.0298 90.4654 32.0544 90.5393C32.0904 90.6453 35.6143 101.271 34.209 113.864C34.2009 113.936 34.14 113.989 34.0694 113.989Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5026 113.078H28.6924V114.602H39.5026V113.078Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M39.5026 113.078H28.6924V114.602H39.5026V113.078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7598 114.601H30.3823C29.4962 116.672 26.6319 122.777 26.6319 124.581C26.6319 126.714 29.275 131.161 29.275 131.161C29.275 131.481 38.8667 131.481 38.8667 131.161C38.8667 131.161 41.5099 126.714 41.5099 124.581C41.5099 122.777 38.6456 116.672 37.7598 114.601Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3219 29.6032C52.9525 29.6032 55.8956 26.6402 55.8956 22.9852C55.8956 19.3302 52.9525 16.3672 49.3219 16.3672C45.6913 16.3672 42.7481 19.3302 42.7481 22.9852C42.7481 26.6402 45.6913 29.6032 49.3219 29.6032Z",
    fill: "#11274B"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.3219 29.6032C52.9525 29.6032 55.8956 26.6402 55.8956 22.9852C55.8956 19.3302 52.9525 16.3672 49.3219 16.3672C45.6913 16.3672 42.7481 19.3302 42.7481 22.9852C42.7481 26.6402 45.6913 29.6032 49.3219 29.6032Z",
    fill: "#EEF7FD"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.3233 29.7397C45.6238 29.7397 42.6143 26.71 42.6143 22.9856C42.6143 19.2612 45.6238 16.2314 49.3233 16.2314C53.0228 16.2314 56.0323 19.2612 56.0323 22.9856C56.0323 26.71 53.0228 29.7397 49.3233 29.7397ZM49.3233 16.5038C45.7731 16.5038 42.8848 19.4115 42.8848 22.9856C42.8848 26.5597 45.7731 29.4674 49.3233 29.4674C52.8735 29.4674 55.7618 26.5597 55.7618 22.9856C55.7618 19.4115 52.8735 16.5038 49.3233 16.5038Z",
    fill: "#11274B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3765 19.3086C50.8002 19.3086 51.7673 20.1538 51.7673 21.5444C51.7673 23.0525 50.705 23.716 49.281 23.716L49.2385 24.5612H48.1865L48.1334 22.8817H48.4838C49.6845 22.8817 50.6091 22.6679 50.6091 21.5447C50.6091 20.796 50.1521 20.3359 49.3872 20.3359C48.6328 20.3359 48.1546 20.7636 48.1546 21.5126H47.0177C47.007 20.2177 47.9316 19.3086 49.3765 19.3086ZM48.6966 26.9247C48.2608 26.9247 47.9207 26.5822 47.9207 26.1439C47.9207 25.7052 48.2608 25.3628 48.6966 25.3628C49.1217 25.3628 49.4618 25.7052 49.4618 26.1439C49.4618 26.5825 49.1217 26.9247 48.6966 26.9247Z",
    fill: "#11274B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4355 28.1483L55.5792 29.2212C55.6917 29.2775 55.8141 29.1652 55.7688 29.0473L54.8308 26.5986C54.3536 27.2813 53.8872 27.8153 53.4355 28.1483Z",
    fill: "#11274B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_482_409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 157,
    height: 144,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavedApplication);
export default __webpack_public_path__ + "static/media/saved-application.60f7f939e6736bf3659281736a490d79.svg";
export { ForwardRef as ReactComponent };